import Slider from "./slider";
import { disableVideo, enableVideo } from "../utils/video";

export default function(el) {
    const slider = Slider(el);
    const tabs = el.querySelectorAll(".ht__tab");

    const changeTabState = (index, slide, actionType) => {
        tabs[index] && tabs[index].classList[actionType]("btn-bounded--active");

        if (actionType === "remove") disableVideo(slide);
        if (actionType === "add") enableVideo(slide);
    };

    if (!slider || tabs.length === 0) return;

    changeTabState(0, slider.getInfo().slideItems[0], "add");

    slider.events.on("indexChanged", (sliderInfo) => {
        changeTabState(sliderInfo.indexCached, sliderInfo.slideItems[sliderInfo.indexCached], "remove");
        changeTabState(sliderInfo.index, sliderInfo.slideItems[sliderInfo.index], "add");
    });

    tabs.forEach((tab, index) => tab.addEventListener("click", () => slider.goTo(index)));
}
